import { OperatingExpenseCalculatedOn } from './constants';

export interface IOtherIncome {
    id: number;
    name: string;
    annualGrowth?: number;
    valuePerUnitPerMonth?: number;
    amountPerYear?: number;
    percentageOfTotalRentalIncome: number;
    calculatedOn?: string;
}

export interface IUnitMix {
    id: number;
    name: string;
    units?: number;
    calculatedOn?: string;
    averageSquareFootage?: number;
    valuePerSfPerMonth?: number;
    valuePerUnitPerMonth?: number;
    amountPerYear?: number;
    amountPerMonth?: number;
    bedrooms?: number;
    bathrooms?: number;
    totalRent?: number;
}

export interface ITenant {
    id: number;
    proFormaOperationsId?: number;
    suite?: string;
    tenant?: string;
    leaseStart?: string;
    rentStart?: string;
    rentGrowth?: number;
    rentStep?: number;
    squareFootage?: number;
    valuePerSfPerYear?: number;
    annualRent?: number;
    recoveryStart?: string;
    calculatedOn?: string;
    totalRent?: number;
}

export enum ExpenseType {
    UNITS = 'units',
    SF = 'sf'
}

export const COST_TYPES = [
    { label: 'per unit', value: ExpenseType.UNITS },
    { label: 'per sf', value: ExpenseType.SF },
];

export interface IExpenses {
    expenses: number;
    valuePerUnitPerYear?: number;
    valuePerSfPerYear?: number;
    amountPerYear: number;
    expensesType: ExpenseType;
    calculatedOn?: OperatingExpenseCalculatedOn;
    isDeleteAllowed?: boolean;
}

export type TUnit = IUnitMix | ITenant;

export interface IWizardStepTwoUses {
    acquisitionCosts: number;
    hardCosts: number;
    totalHardCosts: number;
    hardCostType: string;
    softCosts: number;
    totalSoftCosts: number;
    softCostType: string;
    developerFeePercent?: number;
    developerFee: number;
    interestReserve: number;
}

export interface IProFormaWizardAssumption {
    id?: number;
    dispositionId?: number;
    proFormaId?: number;
    currentMarketCapRate: number;
    projectedCapRateAtSale: number;
    sellingCosts: number;
}
